import React, {useContext, useEffect, useState} from 'react';
import {Row, Col, Button, Table, Pagination, Spinner} from 'react-bootstrap';
import styles from './listing-list.module.scss';
import {IdentityContext} from "../../../../context/identity-context";
import detailsArrowIcon from "../../../../assets/table-details-arrow.svg";
import paginationLeftIcon from "../../../../assets/pagination-arrow-left.svg";
import paginationRightIcon from "../../../../assets/pagination-arrow-right.svg";
import usePagination from "../../../../hooks/use-pagination";
import ListingService from "../../../../services/listing-service";
import {useNavigate} from "react-router-dom";
import Loading from "../../../../components/loading/loading";
import {formatDate, formatDateTime, toCurrency} from "../../../../helpr/helper";
import ModalCustom from '../../../../components/modal/modal';
import { RadioButton } from '../../../../components/form/form';

import {
  TERM_SHEET_CONFIRMED,
  TERM_SHEET_DRAFT,
  TERM_SHEET_REJECTED,
  TERM_SHEET_SUBMITTED
} from "../../../../helpr/constants";


const InstitutionListModal = ({setInstitutionCode, institutionCodeList}) => {
  const dropdownList = institutionCodeList.map((data,index)=>{return {name: data.institutionName, value: data.institutionCode}});
  const [ic, setIC] = useState();
  const onChange = (value) => {
    setIC(value);
  }
  const [inputProps,setInputProps]= useState({
    name: 'institution',
    value: '',
    style: {},
    onChange: onChange
  })
  const onSubmit = () => {
    if(ic){
      setInstitutionCode(ic);
    } else {
      setInputProps(prev=>({...prev,style:{color: 'red'}}))
    }
  }

  return (
    <div className={styles['content']}>
      <RadioButton inputProps={inputProps} data={dropdownList} othersOption={false}>
        Institution:*
      </RadioButton>
      <div className={styles['button']}>
        <Button onClick={()=>onSubmit()}>SELECT</Button>
      </div>
    </div>
  )
}

const ListingList = () => {
  //Set spinner state
  const [loading, setLoading] = useState(true);
  //User information from context
  const { user, role } = useContext(IdentityContext)
  //Use history for redirect
  const navigate = useNavigate();
  //Table Headers
  const tableHeaders = [
    {value: 'Created By', class: ''},
    {value: 'Name of Security', class: ''},
    {value: 'Issue / Reopening Amount', class: 'align-right'},
    {value: 'Maturity Date', class: ''},
    {value: 'Listing Date', class: ''},
    {value: 'Last Update', class: ''},
    {value: 'Status', class: ''}
  ]
  //Listing service for API calls
  const listingService = new ListingService();
  //Set trade list state
  const [termSheetList, setTermSheetList] = useState([]);
  //Create Listing application Modal for Institution Selection
  const [showModal, setShowModal] = useState(false);
  const [institutionCodeList, setInstitutionCodeList] = useState([]);
  const [loadingIC, setLoadingIC] = useState(false);

  useEffect(()=> {
    const retrieveTermSheets = async () => {
      try {
        const result = await listingService.retrieveTermSheets();
        setTermSheetList(result);
      } catch(error){
        navigate(`/internal-server-error`);
      } finally {
        setLoading(false);
      }

    }
    retrieveTermSheets();
    // eslint-disable-next-line
  }, []);


  //Page data
  const pagedData = usePagination(termSheetList,10);
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
    <Pagination.Item
      key={i+1}
      active={(i+1) === pagedData.currentPage}
      onClick={() => pagedData.jump(i+1)}>
      {i+1}
    </Pagination.Item>);

  const renderStatus = status => {
    switch(status) {
      case TERM_SHEET_DRAFT:
        return 'Draft - Pending Submission';
      case TERM_SHEET_SUBMITTED:
        return 'Submitted';
      case TERM_SHEET_CONFIRMED:
        return 'Confirmed';
      case TERM_SHEET_REJECTED:
        return 'Rejected';
      default:
    }
  }

  const loadDesignations = () => {
    async function service () {
      const resp = await listingService.listUnderwriterDesignation();
      if(resp.institutions.length === 1){
        navigate(`/listing/application?ic=${resp.institutions[0].institutionCode}`);
      } else {
        console.log(resp);
        setInstitutionCodeList(resp.institutions);
        setShowModal(true);
        setLoadingIC(false);
      }
    }
    service();
  }

  const setCInstitutionCode = (code) => {
    navigate(`/listing/application?ic=${code}`);
  }

  const createListingApplication = () => {
    if( role === 'Issuer' ){
      navigate('/listing/application?');
    }
    else if( role === 'Underwriter' ){
      setLoadingIC(true);
      loadDesignations();
    }
  }

  return (
    <>
      <div className={`${styles['issuer-info']} ${styles['panel']}`}>
        <Row>
          <Col xs={12} lg={6}>
            <Row>
              <div className={styles['issuer-logo']}>
                <img src={`${process.env.REACT_APP_ASSETS_URL}${user.attributes['custom:icon_url']}`}/>
              </div>
            </Row>
            <Row>
              <div className={styles['issuer-name']}>
                {user.attributes['custom:display_name']}
              </div>
            </Row>
          </Col>
          <Col xs={12} lg={6}>
            <div className={styles['new-listing-button']}>
              <Button onClick={() => createListingApplication()}>
                { loadingIC? <Loading/>: <>Create a Listing/Enrollment</> }
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <div className={`${styles['term-sheet-list']} ${styles['panel']}`} >
        <Row>
          <Col>
            <div className={styles['table-heading']}>
              Listing / Enrollment Events
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {loading ? <Loading /> : (
              <>
                <Table responsive>
                  <thead>
                  <tr>
                    {tableHeaders.map(
                      (header, index) => {
                        return <th className={styles[header['class']]} key={index}>{header.value}</th>
                      }
                    )}
                  </tr>
                  </thead>
                  <tbody>
                  {
                    pagedData.currentData().map((ts, index) => {
                      return (
                        <tr key={index}>
                          <td className={styles['vertical-align']}>
                            {ts.issuerDisplayName}
                          </td>
                          <td>
                            {
                              ts.securityList.length > 0 ? ts.securityList.map((s, index) =>
                                <div key={index}>{s.prefShortName ? s.prefShortName : '-'}</div>) : '-'
                            }
                          </td>
                          <td>
                            {
                              ts.securityList.length > 0 ? ts.securityList.map((s, index) =>
                                <div className={styles['align-right']} key={index}>{`${s.currency} ${toCurrency(s.amount)}`}</div>) : '-'
                            }
                          </td>
                          <td>
                            {
                              ts.securityList.length > 0 ? ts.securityList.map((s, index) =>
                                <div key={index}>{s.maturityDate ? formatDate(s.maturityDate) : '-'}</div>) : '-'
                            }
                          </td>
                          <td className={styles['vertical-align']}>
                            {
                              ts.securityList.length > 0 ? ts.securityList.map((s, index) =>
                                <div key={index}>{s.listingDate ?formatDate(s.listingDate) : '-'}</div>) : '-'
                            }
                          </td>
                          <td className={styles['vertical-align']}>
                            <div>
                              {formatDateTime(ts.lastUpdatedDate)}
                            </div>
                          </td>
                          <td className={styles['vertical-align']}>
                            {renderStatus(ts.applicationStatus)}
                          </td>
                          <td className={`${styles['vertical-align']} ${styles['detail-arrow']}`}
                              onClick={() => navigate(`/listing/${ts.applicationId}?ic=${ts.institutionCode}`)}>
                            <img alt="See Details" src={detailsArrowIcon} />
                          </td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </Table>
                {
                  pagedData.maxPage > 0
                    ? <Pagination>
                      <Pagination.First
                        onClick={() => pagedData.jump(1)}
                        disabled={pagedData.currentPage === 1}>
                        <img alt="FIRST" src={paginationLeftIcon}/>
                      </Pagination.First>
                      <Pagination.Prev
                        onClick={() => pagedData.jump(pagedData.currentPage - 1)}
                        disabled={pagedData.currentPage === 1}>
                        PREV
                      </Pagination.Prev>
                      {pages}
                      <Pagination.Next
                        onClick={() => pagedData.jump(pagedData.currentPage + 1)}
                        disabled={pagedData.currentPage === pagedData.maxPage}>
                        NEXT
                      </Pagination.Next>
                      <Pagination.Last
                        onClick={() => pagedData.jump(pagedData.maxPage)}
                        disabled={pagedData.currentPage === pagedData.maxPage}>
                        <img alt="LAST" src={paginationRightIcon}/>
                      </Pagination.Last>
                    </Pagination> :
                    <div className={styles['no-data']}>No term sheets to display.</div>
                }
              </>
            )}
          </Col>
        </Row>
      </div>
      <ModalCustom
        show={showModal}
        onClose={()=>setShowModal(false)}
        title="Institution Selection"
        component={<InstitutionListModal
            setInstitutionCode={setCInstitutionCode}
            institutionCodeList={institutionCodeList}/>}
        style={styles['designation-modal']}/>
    </>
  )
}

export default ListingList;
